
import { Directive, Output, EventEmitter, Input } from '@angular/core';


import { Cell } from '../../../lib/data-set/cell';

@Directive()
export class EditCellDefault {
  @Input() public cell: Cell;
  @Input() public inputClass: string = '';

  @Output() public edited = new EventEmitter<any>();

  public onEdited(event: any): boolean {
    this.edited.next(event);
    return false;
  }

  public onStopEditing(): boolean {
    this.cell.getRow().isInEditing = false;
    return false;
  }

  public onClick(event: any) {
    event.stopPropagation();
  }
}
